<template>
<div>
  <div v-show="!registWizardFlag">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">관리 대상 목록</div>
        <el-button class="mr-r4" type="secondary" size="mini" @click="onRegistDeviceButton">등록 마법사</el-button>
        <el-button class="mr-r15" size="mini" :disabled="selectedRowArray.length === 0" @click="onDelDevice">장비 삭제</el-button>
        <span class="mr-r5">관리여부</span>
        <div class="setting-addel">
          <el-button size="mini" @click="AllCheckChangeButtonClick('1')"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" @click="AllCheckChangeButtonClick('0')"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-checkbox :checked="beforeThreeDayFlag" v-model="beforeThreeDayFlag" @change="onChangeThreeFlag"> 최근 3일 이내 등록된 장비 <em>{{recentRegisteredE2eCount}}개</em></el-checkbox>
        <el-button class="mr-r4" type="primary" size="mini" @click="onSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button class="mr-r4" size="mini" @click="loadData" :disabled="!cellEditing.isModified">취소</el-button>
        <w-header-pagination class="mr-r4" :pagination="pagination" @current-change="handlerHeaderCurrentChange"></w-header-pagination>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="isLoading" :editable="true" ref="e2eDeviceTable" @condition-change="onChangeTable"
      @selection-change="changeHandleSelection" :data="tableData"
      :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool"
      @pagination-change="handlerPaginationChange"
      @total-change="handlerPaginationChange"
      @cell-dblclick="startEdit"
      :column-default="columnDefault" style="width:100%;" header-align="center" :show-custom-header="true" remote :total="total">
      <template slot-scope="scope" slot="switch-slot">
        <w-switch-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" active-value="1" inactive-value="0" @cell-edit-end="editTwoStatusCell" />
      </template>
      <template slot-scope="scope" slot="input-slot">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="checkbox-slot">
        <w-checkbox-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" true-label="1" false-label="0" @cell-edit-end="editTwoStatusCell" />
      </template>
      <template slot-scope="scope" slot="protocol-slot">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="protocolList"
          keyField="basicinfoSubid" labelField="basicinfoSubid" valueField="basicinfoSubid" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="setting-slot">
        <i class="fas fa-pencil c-pointer" @click="updateTransactionSvc(scope.row)" />
      </template>
    </el-table-wrapper>
  </div>
  <w-e2e-regist-wizard ref="wizardComp" v-show="registWizardFlag" :wizardMode="wizardMode" :agentData="agentData" @load-data="loadData" @on-back-layer-button="onBackLayerButton" @on-regist-device-button="onRegistDeviceButton"></w-e2e-regist-wizard>
</div>
</template>

<script>
import { cloneDeep, isNil, lowerCase } from 'lodash';
import { columnDefault, defaultPagination } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';

import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import DeviceRegistrationE2eApi from '@/api/settings/common/device-registration-e2e';
import rulApi from '@/api/settings/common/rule';

import CellEditingMixin from '@/mixins/table/cell-editing';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WSelectEditor from '@/components/table/cell-editor/SelectEditor';
import WCheckboxEditor from '@/components/table/cell-editor/CheckboxEditor';
import WSwitchEditor from '@/components/table/cell-editor/SwitchEditor';
import WHeaderPagination from '@/components/table/HeaderPagination';
import WE2eRegistWizard from './E2eRegistWizard';

const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WE2eDeviceRegistration',
  mixins: [CellEditingMixin],
  components: {
    WE2eRegistWizard,
    WHeaderPagination,
    WInputEditor,
    WSelectEditor,
    WCheckboxEditor,
    WSwitchEditor,
  },
  props: {
    agentData: Array,
  },
  data() {
    return {
      pagination,
      isLoading: false,
      columnDefault,
      total: null,
      showSearchTool: false,
      delButtonFlag: false,
      selectedRowArray: [],
      tableData: [],
      beforeThreeDayFlag: false,
      recentRegisteredE2eCount: 0,
      protocolList: [],
      loadFromThreeDataFlag: false,
      tableColumn: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objManagementApplyFlag',
          label: '관리여부',
          editable: true,
          scopedSlot: 'switch-slot',
          remoteProp: 'o.obj_management_apply_flag',
          width: 85,
          sortable: true,
          filters: [
            {
              text: '관리',
              value: '1',
            },
            {
              text: '비관리',
              value: '0',
            },
          ],
        },
        {
          prop: 'serviceName',
          label: 'E2E 서비스 명',
          editable: true,
          scopedSlot: 'input-slot',
          sortable: true,
          remoteProp: 'ets.service_name',
          searchable: true,
        },
        {
          prop: 'protocol',
          label: '프로토콜',
          editable: true,
          scopedSlot: 'protocol-slot',
          width: 120,
          searchable: true,
          remoteProp: 'ets.protocol',
        },
        {
          prop: 'httpUrl',
          label: 'URL',
          editable: true,
          scopedSlot: 'input-slot',
          remoteProp: 'ets.http_url',
          searchable: true,
          formatter: this.targetUrlConvert,
        },
        {
          prop: 'eventSetStatus',
          label: '이벤트 제외',
          editable: true,
          scopedSlot: 'checkbox-slot',
          remoteProp: 'eventSetStatus',
          width: 95,
        },
        {
          prop: 'agentCount',
          label: '수집 에이전트',
          remoteProp: 'agentCount',
          width: 100,
        },
        {
          prop: 'registDatetime',
          label: '장비등록일시',
          searchType: 'date',
          formatter: this.getDateFormatter,
          remoteProp: 'o.regist_datetime',
          searchable: true,
          sortable: true,
          width: 130,
        },
        {
          label: '수정',
          align: 'center',
          width: 50,
          scopedSlot: 'setting-slot',
        },
      ],
      rscEventRuleList: [],
      eventAlarmRuleList: [],
      registWizardFlag: false,
      wizardMode: 'add',
    };
  },
  mounted() {
    // 정책 api 호출
    rulApi.getRscEventRules().then((response) => {
      if (response.data.success) {
        this.rscEventRuleList = response.data.data;
      }
    });
    rulApi.getEventAlarmRulesByManagetypeId('E2E').then((response) => {
      if (response.data.success) {
        this.eventAlarmRuleList = response.data.data;
        this.loadData();
      }
    });
    BasicinfoSubAPI.getList('E2E_PROTOCOL').then((response) => {
      if (response.data.success) {
        this.protocolList = response.data.data;
      }
    });
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.e2eDeviceTable.getParameter();
      const params = {
        ...tableParams,
        beforeThreeDayFlag: this.beforeThreeDayFlag,
      };
      // '최근 3일 이내 등록된 장비' 클릭 시 start 값이 기존 값으로 남아있는 문제 인지, 초기화 추가
      if (this.loadFromThreeDataFlag) {
        params.start = 0;
      }
      DeviceRegistrationE2eApi.getRecentRegisteredE2eCount().then((response) => {
        if (response.data.success) {
          this.recentRegisteredE2eCount = response.data.data;
        }
      });
      this.isLoading = true;
      this.loadFromThreeDataFlag = false;
      DeviceRegistrationE2eApi.getE2eTransactionSvcList(params).then((response) => {
        if (response.data.success) {
          this.total = response.data.total;
          this.tableData = this.getEditableTableData(response.data.data, this.tableColumn);
          this.resetCellEditing();
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    /**
     * [테이블 페이징] 페이지 변경 핸들러
     * @author Ju
     * @param  {Object} pagination 페이지 정보 객체
     */
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    /**
     * [헤더 페이징] 현재 페이지 변경 핸들러
     * @author Ju
     * @param  {Number} currentPage 현재 페이지 번호
     */
    handlerHeaderCurrentChange(_currentPage) {
      this.$refs.e2eDeviceTable.setCurrentPage(_currentPage);
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onSaveButton() {
      // 수정 저장 시 eventSetStatus 대상 값이 1일경우는 event_set테이블에 대상 값이 추가될 것이고 0일 경우 삭제된다.
      const updatedData = this.getUpdatedDatas(this.tableData, true, ['objId', 'transactionId', 'serviceId']);

      const target = '관리 대상';
      const action = msgUtil.action.SAVE;
      DeviceRegistrationE2eApi.updateTransactionSvc(updatedData)
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, result.success));
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    // 해당 장비들을 삭제한다.
    onDelDevice() {
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const target = '관리 대상';
        DeviceRegistrationE2eApi.deleteTransactionSvc(this.selectedRowArray)
          .then((response) => {
            const result = response.data;
            if (result.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(action, target, result.success));
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    // 등록 마법사버튼 이벤트
    onRegistDeviceButton() {
      this.wizardMode = 'add';
      this.$nextTick(() => {
        this.$refs.wizardComp.onSettingByWizardMode();
        this.registWizardFlag = true;
      });
    },
    onBackLayerButton() {
      this.registWizardFlag = false;
      // e2e가 대상 db를 사용하고 있다가 해당 db를 팝업창에서 제거할 경우 기존 db 데이터가 남아 있기에 loadData한다.
      this.loadData();
    },
    // 해당 protocol에 맞는 url 변환
    targetUrlConvert(row) {
      let protocol = '';
      if (row.protocol === 'HTTPS') {
        protocol = 'httpUrl';
      } else {
        protocol = `${lowerCase(row.protocol)}Url`;
      }
      return row[protocol];
    },
    AllCheckChangeButtonClick(objManagementApplyFlag) {
      const result = this.editDirectBulk(this.tableData, 'objManagementApplyFlag', objManagementApplyFlag);
      this.tableData = result.tableData;
      this.completeEditBulk(...result);
    },
    handlerEndEdit() {
      this.checkExistModifiedData(this.tableData);
    },
    /**
     * 트랜잭션 서비스 고급설정 위자드를 띄운다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    updateTransactionSvc(record) {
      this.wizardMode = 'update';
      this.$nextTick(() => {
        this.$refs.wizardComp.onSettingByWizardMode(record.objId);
        this.registWizardFlag = true;
      });
    },
    onChangeThreeFlag() {
      this.loadFromThreeDataFlag = true;
      this.$nextTick(() => {
        this.$refs.e2eDeviceTable.setCurrentPage(1);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/E2eDevice/E2eDeviceRegistration.vue